"use strict";function createCloudCall$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.createCloudCall$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.conference.createCloudCall";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.0"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.9"},_a)),exports.createCloudCall$=createCloudCall$,exports.default=createCloudCall$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/conference/createCloudCall.js
// module id = 925
// module chunks = 106